module.exports = __webpack_public_path__ + "static/media/frame-phone.a4441dbc.png";